import { inject, Pipe, PipeTransform } from '@angular/core';
import {
  combineLatest,
  distinctUntilChanged,
  Subject,
  switchMap,
  takeUntil,
} from 'rxjs';
import {
  TranslateService,
  TranslationValues,
} from '../services/translations/translate.service';
import { AbstractPipe } from './abstract.pipe';

@Pipe({
  name: 'translate',
  pure: false, // translation dependant
  standalone: true,
})
export class TranslatePipe extends AbstractPipe implements PipeTransform {
  private readonly _translate: TranslateService = inject(TranslateService);

  private readonly _key$: Subject<string>;
  private readonly _values$: Subject<TranslationValues | undefined>;

  private _translated: string = '';

  public constructor() {
    super();

    this._key$ = new Subject<string>();
    this._values$ = new Subject<TranslationValues | undefined>();

    combineLatest([
      this._key$.pipe(distinctUntilChanged()),
      this._values$.pipe(distinctUntilChanged()),
    ])
      .pipe(
        switchMap(([key, values]: [string, TranslationValues | undefined]) =>
          this._translate.get(key, values)
        ),
        takeUntil(this._destroyed$)
      )
      .subscribe((translated: string) => {
        this._translated = translated;
      });
  }

  /**
   * Translate a string
   */
  public transform(key: string, values?: TranslationValues): string {
    this._key$.next(key);
    this._values$.next(values);

    return key === this._translated ? '' : this._translated;
  }
}
